"use client";
import React from "react";

export default function FooterBasic({data}) {
    const {
        logo,
        bottom = {},
        background = {}
    } = data?.props || {};

    const bgStyle =
        background.type === "color"
            ? {backgroundColor: background.value}
            : background.type === "gradient"
                ? {backgroundImage: background.value}
                : background.type === "image"
                    ? {
                        backgroundImage: `url(${background.value})`,
                        backgroundSize: "cover",
                        backgroundPosition: "center"
                    }
                    : {};

  return (
      <footer className="py-6 text-sm text-gray-400" style={bgStyle}>
          <div className="max-w-6xl mx-auto px-4 flex flex-col sm:flex-row justify-between items-center gap-4">
              {logo?.src && (
                  <a href={logo.href || "/"} className="flex items-center gap-2">
                      <img src={logo.src} alt={logo.alt || "Logo"} className="h-6"/>
                  </a>
              )}

              <div className="text-center sm:text-right">
                  <p>{bottom?.text || "© 2025 Your Company. All rights reserved."}</p>
                  {bottom?.links?.length > 0 && (
                      <div className="flex gap-4 justify-center sm:justify-end mt-1">
                          {bottom.links.map((link, idx) => (
                              <a
                                  key={idx}
                                  href={link.href}
                                  className="hover:text-white transition"
                              >
                                  {link.label}
                              </a>
                          ))}
                      </div>
                  )}
              </div>
          </div>
      </footer>
  );
}